const Form = {
  baseStyle: {
    container: {
      my: '9px',
      
    },
    requiredIndicator: {},
    helperText: {}
  },
};

export default Form;
